import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  extract: {
    indicators: {
      priorities: [],
      profiles: [],
      classifications: [],
      managements: []
    },
    products: [],
    product: {}
  },
  extractLevelTwo: [],
  extractLevelThree: {
    loading: false,
    data: []
  },
  currentExtracts: [],
  currentExtract: {},
  lastPeriodWithData: null,
  received: false,
  fetching: false
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.RECEIVE_EXTRACT: {
      return state
        .setIn(['extract'], action.payload)
        .setIn(['lastPeriodWithData'], action.payload.yearMonth)
        .setIn(['fetching'], false)
        .setIn(['received'], true)
    }

    case types.RECEIVE_EXTRACT_LEVEL_TWO: {
      return state
        .setIn(['extractLevelTwo'], action.payload)
        .setIn(['fetching'], false)
        .setIn(['received'], true)
    }

    case types.RECEIVE_EXTRACT_LEVEL_THREE: {
      return state
        .setIn(['extractLevelThree', 'loading'], false)
        .setIn(['extractLevelThree', 'data'], action.payload)
    }

    case types.RECEIVE_CURRENT_EXTRACTS: {
      return state
        .setIn(['currentExtracts'], action.payload)
        .setIn(['received'], true)
    }

    case types.RECEIVE_CURRENT_EXTRACT: {
      return state
        .setIn(['currentExtract'], action.payload)
        .setIn(['received'], true)
    }

    case types.FETCH_EXTRACT:
    case types.FETCH_EXTRACT_LEVEL_TWO: {
      return state
        .setIn(['fetching'], action.payload)
        .setIn(['received'], !action.payload)
    }

    case types.FETCH_EXTRACT_LEVEL_THREE: {
      return state.setIn(['extractLevelThree', 'loading'], action.payload)
    }

    case types.RECEIVE_PRODUCT: {
      return state.setIn(['extract', 'product'], action.payload)
    }

    case types.CLEAR_EXTRACT: {
      return state
        .setIn(['extract'], INITIAL_STATE.extract)
        .setIn(['currentExtracts'], INITIAL_STATE.currentExtracts)
    }

    case types.CLEAR_EXTRACT_LEVEL_THREE: {
      return state.setIn(['extractLevelThree'], INITIAL_STATE.extractLevelThree)
    }

    default: {
      return state
    }
  }
}

export default reducer
